import React from 'react'

import { Button } from '@octane/spark'
import FormContent from 'components/FormContent'
import { RvAsset } from 'containers/ApplicationSubmissionForms/RVApplication/convertCollateralValues'
import { FieldGroup, Form, FormBuilder, OnSubmit } from 'containers/FormBuilder'
import { useFeatureFlagContext } from 'contexts/FeatureFlagContextProvider'
import RvType from 'state/enums/RvType'

import { makeFieldInstructionBundle } from './fieldInstructions'

interface RvVehicleWriteInProps {
    readonly onSubmit: OnSubmit
    readonly vehicle: RvAsset
}

export default function RvVehicleWriteIn({
    onSubmit,
    vehicle,
}: RvVehicleWriteInProps) {
    const featureFlags = useFeatureFlagContext()

    const fieldInstructionBundle = featureFlags?.invoicePriceForNewRv
        ? makeFieldInstructionBundle(
              'Invoice Price',
              'Invoice Price includes collateral value, discounts and freight',
          )
        : makeFieldInstructionBundle('Sales Price')

    const valuationStipName = featureFlags?.invoicePriceForNewRv
        ? 'Manufacturer Invoice'
        : 'Value Confirmation'

    return (
        <FormBuilder
            fieldInstructionBundle={fieldInstructionBundle}
            onSubmit={onSubmit}
            overrideDefaultInitialValues={{
                assetValue: vehicle.asset_value ?? '',
                model: vehicle.model ?? '',
                rvType: vehicle.rv_type || RvType.CLASS_A,
            }}
        >
            {({ fieldKit }) => {
                return (
                    <Form>
                        <p>
                            Add your vehicle information below. This will allow
                            you to submit for a decision and continue onto Work
                            The Deal.
                        </p>
                        <FormContent gridTemplate="1fr 1fr">
                            <div>
                                Year:
                                <br />
                                {vehicle.year}
                            </div>
                            <div>
                                Make:
                                <br />
                                {vehicle.make}
                            </div>
                        </FormContent>
                        <FormContent gridTemplate="1fr">
                            <FieldGroup
                                fieldInstructionBundle={fieldInstructionBundle}
                                fieldKit={fieldKit}
                            />
                        </FormContent>
                        <p>
                            <strong>Note:</strong> Enter the Model Name as it
                            appears on your Manufacturer Invoice. You must
                            provide the {valuationStipName} Stip before
                            contracts can be generated.
                        </p>
                        <Button type="submit">
                            Add Vehicle and Return to App
                        </Button>
                    </Form>
                )
            }}
        </FormBuilder>
    )
}
